var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Data-continer"},[_c('Detail',{attrs:{"data":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }